import { Outlet } from 'react-router';

export function ServersLayout() {
  return <Outlet />;
}
